import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { compose, setDisplayName } from 'react-recompose';

const HasRoleComponent = ({ anyOf, viewer, children }) => {
  if (viewer.isAuthenticated && [].concat(anyOf).includes(get(viewer, 'idToken["custom:role"]'))) {
    return children;
  } else {
    return null;
  }
};
const HasRole = compose(
  setDisplayName('HasRole'),
  connect((state) => ({ viewer: state.current.viewer })),
)(HasRoleComponent);
HasRole.propTypes = {
  anyOf: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
};
export default HasRole;
